import React from 'react'
import Banner from "./EdgeGateway/banner"
import About from "./EdgeGateway/about"
import WhyUs from "./EdgeGateway/whyus"
import Features from './EdgeGateway/features'
// import TrustUs from './EdgeGateway/trustus'
import TrustUs from '../../pages/main/Home/trustus'
import Connect from './EdgeGateway/connect'

function EdgeGateway() {
  return (
    <div>
      <Banner />
      <About />
      <Features />
      <WhyUs />
      <TrustUs />
      <Connect />
    </div>
  )
}

export default EdgeGateway